<p>login-redirect-component works!</p>
